import React, { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
const InsiderForm = () => {
  const [formData, setFormData] = useState({
    contactName: "",
    email: "",
    phone: "",
    designation: "",
    pharmacyName: "",
    numStores: "",
    increaseClinicalServices: "",
    necessaryFeatures: "",
    additionalFeatures: "",
    acknowledge: false,
  });

  const [errors, setErrors] = useState({});
  const [clicked, setClicked] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const requiredFields = [
    "contactName",
    "email",
    "phone",
    "designation",
    "pharmacyName",
    "numStores",
    "increaseClinicalServices",
    "necessaryFeatures",
    "acknowledge",
  ];

  const validateForm = () => {
    let formErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        formErrors[field] = "This field is required";
      }
    });

    if (formData.necessaryFeatures === "no" && !formData.additionalFeatures) {
      formErrors.additionalFeatures = "This field is required if 'no' is selected";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  useEffect(() => {
    if (clicked) {
      validateForm();
    }
  }, [clicked, formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setClicked(true);
    if (validateForm()) {
      let response = await api.post(`/emailNotification`, {
        contactName: formData.contactName,
        email: formData.email,
        phoneNumber: formData.phone,
        designation: formData.designation,
        organizationName: formData.pharmacyName,
        numberofStores: formData.numStores,
        website: formData.website || "",
        willReelHelpIncreaseClinicalServices:
          formData.increaseClinicalServices === "yes" ? true : false,
        canReelProvideAllNecessaryFeatures:
          formData.necessaryFeatures === "yes" ? true : false,
        acknowledgeIndicatore: formData.acknowledge,
        additionalFeatures: formData.additionalFeatures,
      });
      if(response.data === true) {
        setSuccess(true);
      }
    }
  };

  return (
    <div className="flex flex-col relative items-center justify-start min-h-screen">
      <img
        src="/icons/texture-background.png"
        className="absolute w-full h-full lg:block hidden"
        alt="background"
      />
      <div className="flex relative flex-col lg:rounded-b-[20px]  overflow-hidden border-teal-100 lg:w-[905px]  lg:pb-0 lg:my-[128px]">
        {!success && (
          <div className="lg:rounded-t-[20px]  lg:bg-teal-100 px-6 py-[43px]">
            <h1 className="text-[50px] font-black text-REELTeal lg:text-white lg:max-w-[300px] leading-[50px]">
              Become a <span className="text-teal-300 uppercase">Reel</span>Insider
            </h1>
          </div>
        )}
        {success ? (
          <div className="lg:rounded-t-[20px] min-h-screen lg:h-max  bg-teal-100 px-6 pt-[43px] pb-[143px] flex flex-col justify-center items-center">
            <div className="flex lg:flex-row flex-col items-center space-x-2">
              <img src="/icons/interest-form-check.svg" className="w-[62px] lg:w-8" />
              <p className="text-[20px] leading-[50px] lg:text-[32px] lg:leading-[50px] text-white font-black">
                Interest Form Submitted!
              </p>
            </div>
            <h1 className="text-[50px] font-black text-white lg:text-white mt-[96px] lg:max-w-[350px] leading-[50px]">
              Hooray! You're a <span className="text-teal-300 uppercase">Reel</span>Insider
            </h1>
          </div>
        ) : (
          <form
            className="flex flex-col pb-[100px] lg:py-[25px] px-6 lg:px-[43px] bg-white"
            onSubmit={handleSubmit}
          >
            <div className="flex flex-col ">
              <p className="text-teal-300 text-[24px] leading-[24px] font-black">
                Contact Information
              </p>

              {/* Contact Information Fields */}
              <div className="relative mt-6 w-full">
                <label
                  htmlFor="contactName"
                  className="absolute left-3 -top-2 text-teal-300 font-bold text-[16px] leading-[19px] bg-white"
                >
                  *Contact Name
                </label>
                <input
                  type="text"
                  id="contactName"
                  name="contactName"
                  value={formData.contactName}
                  onChange={handleChange}
                  className="py-3 h-[57px] w-full border-2 border-gray-100 text-gray-900 focus:outline-none focus:ring-0 focus:border-teal-300 rounded-[100px] px-4"
                  placeholder="John Doe"
                />
                {errors.contactName && (
                  <p className="text-red-300 text-sm">{errors.contactName}</p>
                )}
              </div>

              <div className="relative mt-6 w-full">
                <label
                  htmlFor="email"
                  className="absolute left-3 -top-2 text-teal-300 font-bold text-[16px] leading-[19px] bg-white"
                >
                  *Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="py-3 h-[57px] w-full border-2 border-gray-100 text-gray-900 focus:outline-none focus:ring-0 focus:border-teal-300 rounded-[100px] px-4"
                  placeholder="john.doe@example.com"
                />
                {errors.email && (
                  <p className="text-red-300 text-sm">{errors.email}</p>
                )}
              </div>

              <div className="relative mt-6 w-full">
                <label
                  htmlFor="phone"
                  className="absolute left-3 -top-2 text-teal-300 font-bold text-[16px] leading-[19px] bg-white"
                >
                  *Phone Number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="py-3 h-[57px] w-full border-2 border-gray-100 text-gray-900 focus:outline-none focus:ring-0 focus:border-teal-300 rounded-[100px] px-4"
                  placeholder="(123) 456-7890"
                />
                {errors.phone && (
                  <p className="text-red-300 text-sm">{errors.phone}</p>
                )}
              </div>

              <div className="relative mt-6 w-full">
                <label
                  htmlFor="designation"
                  className="absolute left-3 -top-2 text-teal-300 font-bold text-[16px] leading-[19px] bg-white"
                >
                  *Designation/Title
                </label>
                <input
                  type="text"
                  id="designation"
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  className="py-3 h-[57px] w-full border-2 border-gray-100 text-gray-900 focus:outline-none focus:ring-0 focus:border-teal-300 rounded-[100px] px-4"
                  placeholder="Manager"
                />
                <p className="text-gray-800 text-[12px] leading-[14px] font-bold mt-1">
                  e.g., CEO, Pharmacy Director, Pharmacy Owner, Other (please
                  specify)
                </p>
                {errors.designation && (
                  <p className="text-red-300 text-sm">{errors.designation}</p>
                )}
              </div>
            </div>

            <div className="flex flex-col mt-8">
              <p className="text-teal-300 text-[24px] leading-[24px] font-black">
                Pharmacy Information
              </p>

              {/* Pharmacy Information Fields */}
              <div className="relative mt-6 w-full">
                <label
                  htmlFor="pharmacyName"
                  className="absolute left-3 -top-2 text-teal-300 font-bold text-[16px] leading-[19px] bg-white"
                >
                  *Pharmacy Organization Name
                </label>
                <input
                  type="text"
                  id="pharmacyName"
                  name="pharmacyName"
                  value={formData.pharmacyName}
                  onChange={handleChange}
                  className="py-3 h-[57px] w-full border-2 border-gray-100 text-gray-900 focus:outline-none focus:ring-0 focus:border-teal-300 rounded-[100px] px-4"
                  placeholder="Pharmacy Name"
                />
                {errors.pharmacyName && (
                  <p className="text-red-300 text-sm">{errors.pharmacyName}</p>
                )}
              </div>

              <div className="relative mt-6 w-full">
                <label
                  htmlFor="numStores"
                  className="absolute left-3 -top-2 text-teal-300 font-bold text-[16px] leading-[19px] bg-white"
                >
                  *Number of Stores
                </label>
                <input
                  type="number"
                  id="numStores"
                  name="numStores"
                  value={formData.numStores}
                  onChange={handleChange}
                  className="py-3 h-[57px] w-full border-2 border-gray-100 text-gray-900 focus:outline-none focus:ring-0 focus:border-teal-300 rounded-[100px] px-4"
                  placeholder="10"
                />
                {errors.numStores && (
                  <p className="text-red-300 text-sm">{errors.numStores}</p>
                )}
              </div>
            </div>

            <div className="flex flex-col mt-8">
              <p className="text-teal-300 text-[24px] leading-[24px] font-black">
                Additional Questions
              </p>
              <p className="text-body-sm font-normal text-gray-600 text-[14px] leading-[20px] mt-6">
                Please take a moment to complete the following two questions to help
                us understand your needs:
              </p>

              {/* Question 1: Increase Clinical Services */}
              <div className="mt-6">
                <p className="text-gray-600 text-[16px] leading-[24px] font-medium">
                  Do you feel REEL’s Solution will help increase clinical services in
                  your pharmacy organization?
                </p>
                <span className="text-body-sm text-gray-600 font-normal">
                  (e.g., minor ailments, medication reviews, interventions,
                  integrations with key resources, scheduler, and/or additional
                  including addressing vaccines, cardiovascular health, diabetes,
                  respiratory health, chronic disease management, and/or
                  anticoagulation)
                </span>
                <div className="flex items-center mt-4 space-x-4">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="increaseClinicalServices"
                      value="yes"
                      checked={formData.increaseClinicalServices === "yes"}
                      onChange={handleChange}
                      className="w-4 h-4  cursor-pointer  text-teal-50  focus:ring-transparent"
                    />
                    <span className="ml-2 text-body-md text-gray-700 font-medium">
                      Yes
                    </span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="increaseClinicalServices"
                      value="no"
                      checked={formData.increaseClinicalServices === "no"}
                      onChange={handleChange}
                      className="w-4 h-4  cursor-pointer  text-teal-50  focus:ring-transparent"
                    />
                    <span className="ml-2 text-body-md text-gray-700 font-medium">
                      No
                    </span>
                  </label>
                </div>
                {errors.increaseClinicalServices && (
                  <p className="text-red-300 text-sm">
                    {errors.increaseClinicalServices}
                  </p>
                )}
              </div>

              {/* Question 2: Necessary Features */}
              <div className="mt-8">
                <p className="text-gray-600 text-[16px] leading-[24px] font-medium">
                  Do you feel REEL's Solution can provide all the necessary features
                  for your pharmacy organization?
                </p>
                <div className="flex items-center mt-4 space-x-4">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="necessaryFeatures"
                      value="yes"
                      checked={formData.necessaryFeatures === "yes"}
                      onChange={handleChange}
                      className="w-4 h-4  cursor-pointer  text-teal-50  focus:ring-transparent"
                    />
                    <span className="ml-2 text-body-md text-gray-700 font-medium">
                      Yes
                    </span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="necessaryFeatures"
                      value="no"
                      checked={formData.necessaryFeatures === "no"}
                      onChange={handleChange}
                      className="w-4 h-4  cursor-pointer  text-teal-50  focus:ring-transparent"
                    />
                    <span className="ml-2 text-body-md text-gray-700 font-medium">
                      No
                    </span>
                  </label>
                </div>
                {errors.necessaryFeatures && (
                  <p className="text-red-300 text-sm">{errors.necessaryFeatures}</p>
                )}

                {/* Conditional Additional Features Input */}
                {formData.necessaryFeatures === "no" && (
                  <div className="relative mt-6 w-full">
                    <label
                      htmlFor="additionalFeatures"
                      className="  text-gray-600  text-[14px] leading-[20px] mb-2"
                    >
                      If "no," please share any additional features you would like
                      REEL to include
                    </label>
                    <input
                      id="additionalFeatures"
                      name="additionalFeatures"
                      value={formData.additionalFeatures}
                      onChange={handleChange}
                      className="py-3 px-4 mt-1 block w-full shadow-sm focus:ring-teal-300 focus:border-teal-300 border-gray-100 rounded-[100px]"
                      placeholder=""
                    />
                    {errors.additionalFeatures && (
                      <p className="text-red-300 text-sm">
                        {errors.additionalFeatures}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Acknowledgement Checkbox */}
            <div className="flex items-center mt-8">
              <input
                type="checkbox"
                id="acknowledge"
                name="acknowledge"
                checked={formData.acknowledge}
                onChange={handleChange}
                className="form-checkbox h-5 w-5 text-teal-300"
              />
              <label
                htmlFor="acknowledge"
                className="ml-2 text-gray-600 text-[16px] leading-[24px]"
              >
                By checking this box, I acknowledge I am a company administrator,
                part of a pharmacy organization or pharmacy banner, or an independent
                pharmacy owner looking to implement REEL Outline's Clinical Practice
                Solution in a pharmacy.*
              </label>
            </div>
            {errors.acknowledge && (
              <p className="text-red-300 text-sm mt-1">{errors.acknowledge}</p>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              className="bg-REELTeal border border-transparent hover:bg-teal-200 text-white py-2 px-[55px] w-max rounded-[20px] mx-auto mt-10"
            >
              Submit
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default InsiderForm;
